export default __webpack_public_path__ + "static/media/store-top1.9dd7d9f0.jpg";